import React, { useState, useEffect } from 'react'
import "./BankDetails.scss";
import { Card } from 'antd';
import FormInputs from '../../Components/FormInputs/FormInputs';
import Buttons from '../../Components/Buttons/Buttons';
import { GET_ADMIN_BANK_DETAILS, UPDATE_ADMIN_BANK_DETAILS } from '../../Utlis/apiPath';
import { getApi, postApi } from '../../Utlis/apiService';
import { errorToast, successToast } from '../../Services/ToastHelper';
import Loader from '../../Components/Loader/Loader';


const BankDetails = () => {
  const [bankDetails, setBankDetails] = useState({
    bankHolderName: '',
    accountNumber: '',
    ifscCode: '',
    branchName: '',
    accountType: '',
    upiId: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [hasExistingData, setHasExistingData] = useState(false);

  // Fetch bank details on component mount
  useEffect(() => {
    fetchBankDetails();
  }, []);

  const fetchBankDetails = async () => {
    setIsLoading(true);
    try {
      const response = await getApi(GET_ADMIN_BANK_DETAILS);
      
      if (response.status === 200 && response.data) {
        const existingData = response.data;
        setBankDetails({
          bankHolderName: existingData.bankHolderName || '',
          accountNumber: existingData.accountNumber || '',
          ifscCode: existingData.ifscCode || '',
          branchName: existingData.branchName || '',
          accountType: existingData.accountType || '',
          upiId: existingData.upiId || ''
        });
        setHasExistingData(true);
      } else {
        setHasExistingData(false);
      }
    } catch (error) {
      console.error('Error fetching bank details:', error);
      errorToast('Failed to fetch bank details');
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setBankDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleUpdate = async () => {
    // Validate required fields
    if (!bankDetails.bankHolderName || !bankDetails.accountNumber || !bankDetails.ifscCode || !bankDetails.branchName) {
      errorToast('Please fill in all required fields');
      return;
    }

    setIsUpdating(true);
    try {
      const response = await postApi(UPDATE_ADMIN_BANK_DETAILS, bankDetails);
      
      if (response.status === 200) {
        successToast(response.message || 'Bank details updated successfully');
        setHasExistingData(true);
        await fetchBankDetails(); // Refresh the data
      } else {
        errorToast(response.message || 'Failed to update bank details');
      }
    } catch (error) {
      console.error('Error updating bank details:', error);
      errorToast('Failed to update bank details');
    } finally {
      setIsUpdating(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="b_details">
        <div className="b_details_heading">
            <h2>Bank Account details</h2>
        </div>
        
        <Card>
          <div className="b_details_content">
            <div className="b_details_content_bank">
              <FormInputs 
                title="Bank Holder Name" 
                placeholder="Enter Name" 
                value={bankDetails.bankHolderName}
                onChange={(e) => handleInputChange('bankHolderName', e.target.value)}
              />
              <FormInputs
                title="Account Number"
                placeholder="Enter Account Number"
                value={bankDetails.accountNumber}
                onChange={(e) => handleInputChange('accountNumber', e.target.value)}
              />
              <FormInputs 
                title="IFSC Code" 
                placeholder="Enter IFSC Code" 
                value={bankDetails.ifscCode}
                onChange={(e) => handleInputChange('ifscCode', e.target.value)}
              />
              <FormInputs 
                title="Branch Name" 
                placeholder="Branch Name" 
                value={bankDetails.branchName}
                onChange={(e) => handleInputChange('branchName', e.target.value)}
              />
              <FormInputs 
                title="Account Type" 
                placeholder="Enter Account Type (e.g., Savings, Current)" 
                value={bankDetails.accountType}
                onChange={(e) => handleInputChange('accountType', e.target.value)}
              />
              <FormInputs 
                title="UPI ID" 
                placeholder="Enter UPI ID (optional)" 
                value={bankDetails.upiId}
                onChange={(e) => handleInputChange('upiId', e.target.value)}
              />
            </div>
            <div className="b_details_content_btn">
              <Buttons 
                variant="primary" 
                onClick={handleUpdate}
                disabled={isUpdating}
              >
                {isUpdating ? 'Updating...' : hasExistingData ? 'Update' : 'Save'}
              </Buttons>
            </div>
          </div>
        </Card>
    </div>
  )
}

export default BankDetails
